import Carousel from "../_modules/carousel/carousel";
import VideoPlayer from "../_modules/molecules/video-player/video-player";

export function initCarousel(
  $carousel = $("[data-carousel]", this.$selector),
  options,
  slickInit = true,
  init = null,
  before = null,
  after = null,
  setPos = null,
  callback = null
) {
  const carousel = new Carousel(
    $carousel,
    true,
    options,
    init,
    before,
    after,
    setPos,
    slickInit
  );

  if (callback) callback();

  return carousel;
}

export function setBodyToFixed() {
  $("body").css({
    overflow: "hidden",
  });
}

export function setBodyPos() {
  $("body").css({
    overflow: "auto",
  });
}

export function stackedCarousel(
  $selector,
  carouselOptions,
  maxItems
) {
  let current = 0; // to track current slide to set classnames on breakpoint reinit

  let initSlick = (e, slick) => {
    $(`[data-slick-index=${current}]`, $selector).addClass(
      "slick-slide--next0"
    );

    if ($(`[data-slick-index=${current + 1}]`, $selector).length)
      $(`[data-slick-index=${current + 1}]`, $selector).addClass(
        "slick-slide--next1"
      );

    if ($(`[data-slick-index=${current + 2}]`, $selector).length)
      $(`[data-slick-index=${current + 2}]`, $selector).addClass(
        "slick-slide--next2"
      );

    if ($(`[data-slick-index=${current + 3}]`, $selector).length)
      $(`[data-slick-index=${current + 3}]`, $selector).addClass(
        "slick-slide--next3"
      );

    if ($(`[data-slick-index=${current + 4}]`, $selector).length)
      $(`[data-slick-index=${current + 4}]`, $selector).addClass(
        "slick-slide--next4"
      );
  };

  const beforeChange = (e, slick, currentSlide, nextSlide) => {
    current = currentSlide;

    // determine forward step
    let isForward = false;

    if (nextSlide > currentSlide) {
      if (nextSlide - currentSlide >= 2) {
        isForward = false;
      } else {
        isForward = true;
      }
    } else {
      if (currentSlide - nextSlide >= 2) {
        isForward = true;
      } else {
        isForward = false;
      }
    }

    if (isForward) {
      // going forward
      $("[data-slick-index]", $selector).map((i, ele) => {
        const slideIndex = parseInt($(ele).data("slick-index"));

        const newIndex =
          slideIndex - currentSlide - 1 < 0
            ? slideIndex - currentSlide - 1 + maxItems
            : slideIndex - currentSlide - 1;
        const currentIndex =
          slideIndex - currentSlide < 0
            ? slideIndex - currentSlide + maxItems
            : slideIndex - currentSlide;
        $(ele)
          .addClass(`slick-slide--next${newIndex}`)
          .removeClass(`slick-slide--next${currentIndex}`);
      });
    } else {
      // going backwards
      $("[data-slick-index]", $selector).map((i, ele) => {
        const slideIndex = parseInt($(ele).data("slick-index"));
        const step =
          maxItems - currentSlide >= maxItems ? 0 : maxItems - currentSlide;

        const newIndex =
          slideIndex + step + 1 >= maxItems
            ? slideIndex + step + 1 - maxItems
            : slideIndex + step + 1;
        const currentIndex =
          slideIndex + step >= maxItems
            ? slideIndex + step - maxItems
            : slideIndex + step;
        $(ele)
          .addClass(`slick-slide--next${newIndex}`)
          .removeClass(`slick-slide--next${currentIndex}`);
      });
    }
  };

  const carousel = initCarousel(
    $("[data-carousel]", $selector),
    carouselOptions,
    true,
    initSlick,
    beforeChange
  );

  return carousel;
}

export function initModalVideoPlayer($selector) {
  if ($(".video-player", $selector).length) {
    const players = [];
    const videoPlayers = [];

    $(".video-player", $selector).map((i, video) => {
      $(video)
        .find(".video-player__holder")
        .attr("id", $(video).data("videoId"));
      const playerData = {
        id: $(video).data("videoId"),
        videoId: $(video).data("videoId"),
        YTPlayer: null,
      };
      players.push(playerData);
      const videoPlayerInstance = new VideoPlayer($(video), true, playerData);
      videoPlayers.push(videoPlayerInstance);

      players.map((player, i) => {
        player.YTPlayer = new YT.Player(player.id, {
          videoId: player.videoId,
          events: {
            onReady: (e) => {
              videoPlayers[i].onReady($(".video-player").eq(i));
            },
          },
        });
      });
    });
  }
}

export function setTimerUI($selector, targetDate) {
  // Get today's date and time
  const now = new Date().getTime();
    
  // Find the distance between now and the count down date
  const distance = targetDate - now;

  // Time calculations for days, hours, minutes and seconds
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  (days > 9) ? $('.day .counter', $selector).text(days) : $('.day .counter', $selector).text(`0${days}`);
  (hours > 9) ? $('.hour .counter', $selector).text(hours) : $('.hour .counter', $selector).text(`0${hours}`);
  (minutes > 9) ? $('.min .counter', $selector).text(minutes) : $('.min .counter', $selector).text(`0${minutes}`);
  (seconds > 9) ? $('.sec .counter', $selector).text(seconds) : $('.sec .counter', $selector).text(`0${seconds}`);
}